import React from "react";
import { Link } from "react-router-dom";

function CbOSEMainContainer({ containerObject, templateName, contentId, dataZone }) {
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className="vast-plugin-content">
            {/* banner */}
            <div class="banner">
                <section class="os-top-banner">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 col-md-5 mb-4 px-4">
                                <h1 class="os-banner-heading mb-4">Carolina and OpenSciEd have partnered to make high-quality instructional materials even better.</h1>
                                <Link class="btn btn-os-outline-primary" to="/ose/openscied-carolina-ccv-page">Learn More</Link></div>

                            <div class="col-12 col-md-7">
                                <div class="os-top-banner-right">
                                    <div class="os-top-banner-img">
                                        <img alt="OSE" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/top-banner-right-bg.png" />
                                        <div class="os-top-banner-profile os-home-top-banner">
                                            <img alt="OSE" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/os-home-banner.png" /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="os-hero"><img class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/home-top-top-wave.svg" /></div>
                    <div class="os-hero2"><img class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/home-top-bottom-wave.svg" /></div>
                </section>
            </div>
            {/* banner */}
            {/* os-ccv-section */}
            <section class="os-ccv-section">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-6 col-xxl-5">
                            <div class="os-ccv-left">
                                <h2>OpenSciEd is high-quality science instructional materials.</h2>
                                <p>Like any curriculum, OpenSciEd requires materials and support. When you partner with Carolina, you get everything you need for classroom success from a single, trusted, and reliable supplier. Carolina Certified Versions offer:</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-xxl-7">
                            <div class="d-flex justify-content-end">
                                <a href="https://www.edreports.org/reports/overview/openscied-2023">
                                    <img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/ccv-offer-toprated.png" />
                                </a></div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="os-ccv-items-section d-block d-md-none">
                <div class="container">
                    <div class="row g-0">
                        <div class="col-12 col-md-8">
                            <div class="os-ccv-offer-img">
                                <img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/ccv-offer-items.png" /></div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="ccv-offer-item ccv-offer-item-01">
                                <h3>Redesigned</h3>
                                <p>Redesigned and reformatted print materials that are easier to read and follow</p>
                            </div>
                            <div class="ccv-offer-item ccv-offer-item-02">
                                <h3>Simplified</h3>
                                <p>Simplified investigations and materials to reduce teacher prep and classroom instructional time</p>
                            </div>
                            <div class="ccv-offer-item ccv-offer-item-03">
                                <h3>Digital</h3>
                                <p>Digital resources to engage students, support teachers, and report to administrators</p>
                            </div>
                            <div class="ccv-offer-item ccv-offer-item-04">
                                <h3>Tested</h3>
                                <p>Tested lessons and materials to ensure safety, quality, and accuracy of investigations</p>
                            </div>
                            <div class="ccv-offer-item ccv-offer-item-05">
                                <h3>ADA Compliance</h3>
                                <p>ADA compliance of instructional materials to support equity</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="cso-ccv-focus-img text-center d-none d-md-block">
                <img alt="..." class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/home-offer-bg.jpg" />
            </section>
            {/* os-ccv-section */}

            <section class="os-ccv-items">
                <div class="os-blue-wave-top">
                    <img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/home-blue-wave-top.svg" /></div>
                <div class="os-ccv-content">
                    <div class="container-fluid g-0">
                        <div class="row g-0">
                            <div class="col-12 col-md-6 col-xxl-6 order-1 order-md-0">
                                <div class="os-ccv-items-left">
                                    <img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/young-boy.png" />
                                </div>
                                <div class="os-ccv-items-lef-logo">
                                    <img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/badge.png" />
                                </div>
                            </div>

                            <div class="col-12 col-md-6 col-xxl-6 order-0 order-md-1">
                                <div class="os-ccv-items-right">
                                    <div><img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/high-qality.png" /></div>
                                    <p>High-quality instructional content from OpenSciEd.</p>
                                </div>

                                <div class="os-ccv-items-right">
                                    <div><img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/materials.png" /></div>
                                    <p>Materials and production expertise from Carolina</p>
                                </div>
                                <div class="os-ccv-items-right">
                                    <div><img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/dedicated.png" /></div>
                                    <p>Dedicated service and support from Carolina</p>
                                </div>
                                <div class="os-ccv-items-actions d-none d-md-block">
                                    <Link class="btn btn-os-outline-primary" to="/ose/openscied-carolina-more-carolina">LEARN MORE</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="os-blue-wave-bottom">
                    <img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/home-blue-wave-bottom.svg" />
                </div>
            </section>

            {/* includes */}
            <section class="os-ccv-includes">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-12">
                            <h2>Carolina Certified Versions include:</h2>
                        </div>
                    </div>

                    <div class="row g-md-0">
                        <div class="col-12 col-md-3">
                            <div class="os-include-item os-include-content-position-01">
                                <div><img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/inclue-kits.png" /></div>
                                <div class="os-include-content ">
                                    <h3>Kits &amp; Materials</h3>
                                    <p>Flexible and all-inclusive options for complete kits, refurbishment materials, and individual components</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-3">
                            <div class="os-include-item os-include-content-position-02">
                                <div><img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/include-print.png" /></div>
                                <div class="os-include-content">
                                    <h3>Redesigned Print</h3>
                                    <p>Unique versions of Teacher and Student Editions</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-3">
                            <div class="os-include-item os-include-content-position-03">
                                <div><img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/include-digital.png" /></div>
                                <div class="os-include-content">
                                    <h3>Enhanced Digital</h3>
                                    <p>Class licenses allow for assignable, interactive content for students and reporting for teachers and administrators</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-3">
                            <div class="os-include-item os-include-content-position-04">
                                <div><img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/include-packages.png" /></div>
                                <div class="os-include-content">
                                    <h3>Professional Learning</h3>
                                    <p>Implementation support from Certified Professional Learning facilitators</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row g-md-0 os-home-include-more">
                        <div class="col-12 text-center">
                            <Link class="btn btn-os-primary" to="/ose/openscied-carolina-more-carolina">LEARN MORE</Link>
                        </div>
                    </div>
                </div>
            </section>
            {/* includes */}

            <section class="os-footer-banner">
                <div class="container-fluid g-0">
                    <div class="row g-0 ">
                        <div class="col-12">
                            <div class="os-partner-top">
                                <img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/footer-regions-wave.svg" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-4 d-flex flex-column justify-content-center order-1 order-md-0">
                            <h2 class="os-footer-banner-title">You should partner with Carolina, too.</h2>
                            <p class="os-footer-banner-content">
                                Like any curriculum, OpenSciEd requires materials and support. When you partner with Carolina, you get everything you need for classroom success from a single trusted and reliable supplier.</p>
                            <div class="os-footer-btn"><Link class="btn btn-os-outline-primary" to="/ose/openscied-carolina-contact-page">Contact Us</Link></div>
                        </div>

                        <div class="col-12 col-md-8 order-0 order-md-1">
                            <div class="os-footer-banner-right">
                                <img alt="ose" class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/footer-banner-right-img.png" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default CbOSEMainContainer